export default __webpack_public_path__ + "static/media/NumberOfTrialsWithPublicationsIcon.1d9d7aed.svg";